import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import SEO from './SEO';
import { ingredientData, getIngredientCategories } from '../data/ingredientData';
import './IngredientList.css';

function IngredientList() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = useMemo(() => getIngredientCategories(), []);

  const filteredIngredients = useMemo(() => {
    if (selectedCategory === 'all') return ingredientData;
    return ingredientData.filter(
      (ingredient) => ingredient.category === selectedCategory
    );
  }, [selectedCategory]);

  function truncate(text, maxLength) {
    if (!text || text.length <= maxLength) return text;
    return text.slice(0, maxLength).trimEnd() + '...';
  }

  return (
    <div className="App">
      <SEO
        title="Pore Clogging Ingredients to Avoid | Acne Safe"
        description="Browse all known pore-clogging ingredients that can cause breakouts. Learn what each ingredient does, why it clogs pores, and which products to watch out for."
        keywords="pore clogging ingredients, comedogenic ingredients, acne causing ingredients, ingredients to avoid acne, non comedogenic"
        url="https://www.useacnesafe.com/ingredients"
      />
      <Header />

      <main className="ingredient-list-page">
        <section className="ingredient-list-header">
          <h1>Pore Clogging Ingredients</h1>
          <p>
            Learn which ingredients to avoid if you're acne-prone. Tap any
            ingredient for a full breakdown.
          </p>
        </section>

        <section className="ingredient-list-controls">
          <div className="ingredient-categories">
            <button
              className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('all')}
            >
              All
            </button>
            {categories.map((category) => (
              <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        <section className="ingredient-results-meta" aria-live="polite">
          <p>
            {filteredIngredients.length} ingredient
            {filteredIngredients.length === 1 ? '' : 's'}
            {selectedCategory !== 'all' ? ` in ${selectedCategory}` : ''}
          </p>
        </section>

        <section className="ingredient-grid">
          {filteredIngredients.map((ingredient) => (
            <article key={ingredient.slug} className="ingredient-card">
              <Link
                to={`/ingredients/${ingredient.slug}`}
                className="ingredient-card-link"
              >
                <div className="ingredient-card-top">
                  <span className="ingredient-category-badge">
                    {ingredient.category}
                  </span>
                </div>
                <h2>{ingredient.name}</h2>
                <p className="ingredient-card-desc">
                  {truncate(ingredient.description, 80)}
                </p>
              </Link>
            </article>
          ))}
        </section>

        {filteredIngredients.length === 0 && (
          <section className="ingredient-list-message">
            No ingredients found. Try a different category.
          </section>
        )}
      </main>
    </div>
  );
}

export default IngredientList;
